import { queryDictExpend } from '@api/core/dict';

// 按模块的action, reducer整合体
const EXPEND_TYPE = 'EXPEND_TYPE';

export function getExpendType() {
  return (dispatch, getState) => {
    const { expend_type: type } = getState();
    if (type.length > 0) {
      return dispatch({
        type: EXPEND_TYPE,
        data: type,
      });
    }
    return queryDictExpend().then(res => {
      if (res.statusCode === 200) {
        return dispatch({
          type: EXPEND_TYPE,
          data: res.data,
        });
      }
    });
  };
}

export function expendType(state = [], action) {
  switch (action.type) {
    case EXPEND_TYPE:
      return action.data;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/finance/expend_type.js